import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { AppConst } from '@app/App.const';
import { ApiEndpointsService } from '../api-endpoint.service';
import { ApiHttpService } from '../api-http.service';

@Injectable({
  providedIn: 'root',
})
export class ModuleLevelPermissionService {
  
  private readonly _moduleLevelPermissionDetails = new ReplaySubject<any>(1);

  // Expose read-only observable
  public readonly moduleLevelPermisssionDetails$: Observable<any> =
    this._moduleLevelPermissionDetails.asObservable();

  // Single write-path
  updateModuleLevelPermission(details: any): void {
    this._moduleLevelPermissionDetails.next(details);
  }


  constructor(
    private api: ApiHttpService,
    private apiEndpoint: ApiEndpointsService
  ) {}

  public getModuleLevelPermission() {
    return this.api.callApi(
      AppConst.HttpMethods.GET,
      this.apiEndpoint.getModuleLevelPermission(),
      null
    );
  }

  public invokeModulePermissionDetails(data: any) {
    this._moduleLevelPermissionDetails.next(data);
  }
}
